(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('.mc-product-gallery').forEach((section) => {
      if (section.dataset.mcGalleryReady === 'true') return;

      const media = section.querySelector('.mc-product-gallery-wrapper');
      if (!media) return;
      section.dataset.mcGalleryReady = 'true';

      const viewer = media.querySelector('.product__media-list');
      if (viewer) {
        const blockMiddleClick = (event) => {
          if (event.button === 1) event.preventDefault();
        };
        viewer.addEventListener('mousedown', blockMiddleClick);
        viewer.addEventListener('auxclick', blockMiddleClick);
      }
      const updateViewerHeight = () => {
        if (!viewer) return;
        const active = viewer.querySelector('.product__media-item.is-active') || viewer.querySelector('.product__media-item');
        if (!active) return;
        const container = active.querySelector('.product-media-container') || active;
        const height = Math.ceil(container.getBoundingClientRect().height);
        if (height > 0 && viewer.style.height !== `${height}px`) {
          viewer.style.height = `${height}px`;
        }
      };

      const updateGallery = () => {
        updateViewerHeight();
        if (window.innerWidth < 990) {
          media.style.removeProperty('--mc-gallery-top');
          return;
        }

        const header = document.querySelector('sticky-header, header');
        const headerHeight = header ? header.getBoundingClientRect().height : 0;
        const preferredTop = Math.min(headerHeight + 12, 92);
        const visibleTop = window.innerHeight - media.scrollHeight - 16;
        media.style.setProperty('--mc-gallery-top', `${Math.round(Math.min(preferredTop, visibleTop))}px`);
      };

      const scheduleUpdate = () => window.requestAnimationFrame(updateGallery);
      const observer = new ResizeObserver(scheduleUpdate);
      observer.observe(media);
      if (viewer) {
        const activeObserver = new MutationObserver(scheduleUpdate);
        activeObserver.observe(viewer, { subtree: true, attributes: true, attributeFilter: ['class'] });
        viewer.querySelectorAll('img').forEach((image) => image.addEventListener('load', scheduleUpdate));
      }
      window.addEventListener('resize', scheduleUpdate, { passive: true });
      updateGallery();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();

